import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { getUserByToken } from "./customerCrud";

export const actionTypes = {
    CustomerRequested: "[Request customer] Action",
    CustomerUpdated: "[Update customer] Action",
    ActionsLoading: "[Actions Loading] Action"
};

const initialCustomerState = {
    user: undefined,
    customer: undefined,
    actionsLoading: true
};

export const reducer = persistReducer(
    { storage, key: "trendyol-key", whitelist: ["customer"] },
    (state = initialCustomerState, action) => {
        switch (action.type) {
            case actionTypes.CustomerRequested: {
                const { user, customer } = action.payload;
                state.actionsLoading = false;
                return { ...state, user, customer };
            }

            case actionTypes.CustomerUpdated: {
                const { user, customer } = action.payload;
                return { ...state, user, customer };
            }

            case actionTypes.ActionsLoading: {
                return { ...state, actionsLoading: action.payload}
            }

            default:
                return state;
        }
    }
);

export const actions = {
    requestCustomer: (user, customer) => ({ type: actionTypes.CustomerRequested, payload: { user, customer } }),
    fulfillCustomer: data => ({ type: actionTypes.CustomerUpdated, payload: { data } }),
    changeActionsLoading: data => ({ type: actionTypes.ActionsLoading, payload: {data} })
};

export function* saga() {
    yield takeLatest(actionTypes.CustomerRequested, function* requestCustomer() {
        const { data : response } = yield getUserByToken();

        yield put(actions.fulfillCustomer(response.data));
    });

    yield takeLatest(actionTypes.CustomerUpdated, function* requestCustomer() {
        const { data : response } = yield getUserByToken();

        yield put(actions.fulfillCustomer(response.data));
    });
}
